export default "__VITE_ASSET__DplXL1cI__"